import { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import browserHistory from '../../history';
import FaceSigninApp from '../../facesignin/App';

class FaceVerifyPage extends Component {
    constructor(props) {
        super(props);
        const state = (props.location && props.location.state) || {};
        this.role = state.userType || 'creator';
    }

    handleComplete(session) {
        const role = (session && session.role) || this.role;
        browserHistory.push({
            pathname: '/',
            state: { userType: role },
        });
    }

    render() {
        return (
            <div className="info-page">
                <Header />
                <div style={{
                    minHeight: 'calc(100vh - 180px)',
                    backgroundColor: 'var(--mainbgColor, #15171b)',
                    paddingTop: '60px',
                }}>
                    <div style={{ width: '100%', padding: '32px 24px' }}>
                        <FaceSigninApp
                            initialRole={this.role}
                            onComplete={(session) => this.handleComplete(session)}
                        />
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default FaceVerifyPage;
